<template>
    <div class="results">
        <h1 class="mb-4 mt-5 border-bottom border-secondary border-3 pb-1">{{ initiative.title }}</h1>
        <div class="row">
            <div class="col-sm-6 mb-3">
                <div class="row pb-3">
                    <div class="col">
                        <h3 class="d-inline">Assigned Results</h3>
                        <button type="button" 
                            class="btn btn-sm btn-secondary float-end"
                            data-bs-toggle="modal" 
                            data-bs-target="#cost-result-modal"
                            @click="modal_version = 'Result'">
                            <i class="fa fa-plus"></i> Add Result
                        </button>
                    </div>
                </div>
                <div class="card" v-if="init.results_filter === null || init.results_filter.length === 0">
                    <div class="card-body p-2">
                        <div class="p-2">None Added Yet</div>
                    </div>
                </div>
                <template v-else>
                    <div class="card mb-2" v-for="result in init.results_filter" :key="result.id">
                        <div class="card-body p-2">
                            <div class="accordion accordion-flush">
                                <div class="accordion-item border-bottom-0">
                                    <div class="row accordion-header">
                                        <div class="col col-sm-8 col-md-9">
                                            <button class="btn btn-link text-start collapsed p-2" 
                                                type="button"
                                                :data-bs-target="'#result-' + result.id" 
                                                data-bs-toggle="collapse"
                                                aria-expanded="false" 
                                                :aria-controls="'#result-' + result.id">
                                                <strong>{{ ((result.data_source_name !== undefined) ? propercase(result.data_source_name) : propercase(result.data_source)) }}</strong>: {{ result.description }}
                                            </button>
                                        </div>
                                        <div class="col">
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="deleteResult(result)">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="editResult(result)" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#cost-result-modal">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                            </button>
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="previewTable(result)" 
                                                v-if="result.data_source !== 'manual'">
                                                <i class="fa fa-eye"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div :id="'result-' + result.id" 
                                        class="collapse accordion-collapse"
                                        v-if="result.data_source === 'manual'">
                                        <div class="accordion-body">
                                            <strong>Date:</strong> {{ date(result.date) }}<br>
                                            <strong>Emails:</strong> {{ number_with_zero(result.emails) }}<br>
                                            <strong>Gifts:</strong> {{ number_with_zero(result.gifts) }}<br>
                                            <strong>New Donors:</strong> {{ number_with_zero(result.new_donors) }}<br>
                                            <strong>Revenue:</strong> {{ currency_with_zero(result.revenue) }}<br>
                                            <strong>Recurring Revenue:</strong> {{ currency_with_zero(result.recurring_revenue) }}
                                        </div>
                                    </div>
                                    <div :id="'result-' + result.id" 
                                        class="collapse accordion-collapse" 
                                        v-else>
                                        <div class="accordion-body">
                                            <strong>Filter Logic:</strong><br>
                                            <div style="line-height: 2.4em;" v-html="logicToString(result.value.filter_logic, result.value.logic_units)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="col mb-3">
                <div class="row pb-3">
                    <div class="col">
                        <h3 class="d-inline">Assigned Costs</h3>
                        <button type="button" 
                            class="btn btn-sm btn-secondary float-end"
                            data-bs-toggle="modal" 
                            data-bs-target="#cost-result-modal"
                            @click="modal_version = 'Cost'">
                            <i class="fa fa-plus"></i> Add Cost
                        </button>
                    </div>
                </div>
                <div class="card" v-if="init.costs_filter === null || init.costs_filter.length === 0">
                    <div class="card-body p-2">
                        <div class="p-2">None Added Yet</div>
                    </div>
                </div>
                <template v-else>
                    <div class="card mb-2" v-for="cost in init.costs_filter" :key="cost.id">
                        <div class="card-body p-2">
                            <div class="accordion accordion-flush">
                                <div class="accordion-item border-bottom-0">
                                    <div class="row accordion-header">
                                        <div class="col col-sm-8 col-md-9">
                                            <button class="btn btn-link text-start collapsed p-2" 
                                                type="button"
                                                :data-bs-target="'#cost-' + cost.id" 
                                                data-bs-toggle="collapse"
                                                aria-expanded="false" 
                                                :aria-controls="'#cost-' + cost.id">
                                                <strong>{{ ((cost.data_source_name !== undefined) ? propercase(cost.data_source_name) : propercase(cost.data_source)) }}</strong>: {{ cost.description }}
                                            </button>
                                        </div>
                                        <div class="col">
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="deleteCost(cost)">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="editCost(cost)" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#cost-result-modal">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                            </button>
                                            <button type="button" 
                                                class="btn-xs btn-none float-end p-2" 
                                                @click="previewTable(cost)" 
                                                v-if="cost.data_source !== 'manual'">
                                                <i class="fa fa-eye"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div :id="'cost-' + cost.id" 
                                        class="collapse accordion-collapse"
                                        v-if="cost.data_source === 'manual'">
                                        <div class="accordion-body">
                                            Total: {{ currency_with_zero(cost.amount) }}<br>
                                            Date: {{ date(cost.date) }}<br>
                                            Cost Type: {{ propercase(cost.cost_type) }}
                                        </div>
                                    </div>
                                    <div :id="'cost-' + cost.id" 
                                        class="collapse accordion-collapse" 
                                        v-else>
                                        <div class="accordion-body">
                                            <strong>Filter Logic:</strong><br>
                                            <div style="line-height: 2.4em;" v-html="logicToString(cost.value.filter_logic, cost.value.logic_units)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="row" v-if="table_data !== null">
            <div class="col mb-3">
                <div class="card">
                    <div class="card-body p-0">
                        <div v-if="typeof table_data === 'string' && table_data === ''" class="m-3">
                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <span class="ms-2">Loading...</span>
                        </div>
                        <template v-else-if="Array.isArray(table_data) && table_data.length > 0">
                            <div class="overflow-hidden rounded-top">
                                <div class="p-1 bg-dark"></div>
                            </div>
                            <div class="table-responsive gy-0 m-0 mb-2">
                                <table class="table gy-0 m-0">
                                    <thead class="table-dark">
                                        <tr>
                                            <th v-for="(row, index) in Object.keys(table_data[0])" 
                                                :key="row"
                                                class="align-middle pt-0"
                                                :class="{ 'ps-3': index === 0 }">
                                                {{ propercase(row) }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-border-bottom-0">
                                        <tr v-for="(row, rowIndex) in table_data" :key="rowIndex">
                                            <td v-for="(col, index) in row" 
                                                :key="index"
                                                :class="{ 'ps-3': index === 0 }">
                                                {{ col }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <div v-else-if="Array.isArray(table_data) && table_data.length === 0">
                            <div class="alert alert-warning box-content">
                                No data was returned.
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-danger box-content">
                                There was an error pulling the data:<br>
                                <em>{{ table_data }}</em>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <cost-result-modal 
            v-model:modal_version="modal_version" 
            v-model:initiative="init"
            :client="client" 
            :filter="filter">
        </cost-result-modal>
        <div class="row">
            <div class="col">
                <a :href="'/results/' + client.url + '/projections'" class="btn btn-primary mt-4">
                    <img class="icon" src="/img/icons/avid-icons/save.svg" alt=""> Update
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CostsResults',
    props: {
        initiative: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            init: null,
            modal_version: null,
            filter: {
                data_source: "manual",
                data_source_name: "Manual",
                title: "",
                value: null,
                date: null,
                cost_type: 'media_cost',
                emails: 0,
                gifts: 0,
                revenue: 0,
                new_donors: 0,
                recurring_revenue: 0,
                id: null,
                exclude_other_initiatives: false
            },
            errors: {
                date: "",
                title: "",
                value: ""
            },
            form: {
                error: false
            },
            table_data: null
        };
    },
    watch: {
        init(oldVal, newVal) {
            //Reset the filter if the initiative gets updated
            this.resetFilter();
        },
        modal_version(oldVal, newVal) {
            //If they closed the modal, then wipe the filter
            if(oldVal === null)
                this.resetFilter();
        }
    },
    beforeMount() {
        this.init = this.initiative;
    },
    methods: {
        resetFilter() {
            this.filter.data_source = "manual";
            this.filter.data_source_name = "";
            this.filter.title = "";
            this.filter.value = null;
            this.filter.date = null;
            this.filter.cost_type = 'media_cost';
            this.filter.emails = 0;
            this.filter.gifts = 0;
            this.filter.revenue = 0;
            this.filter.new_donors = 0;
            this.filter.recurring_revenue = 0;
            this.filter.id = null;
            this.filter.exclude_other_initiatives = false;
        },
        editCost(cost) {
            this.filter.data_source = cost.data_source;
            this.filter.data_source_name = cost.data_source_name;
            this.filter.title = cost.description;
            this.filter.date = cost.date;
            this.filter.cost_type = cost.cost_type;
            this.filter.id = cost.id;
            
            if(this.filter.data_source === 'manual')
                this.filter.value = cost.amount;
            else
                this.filter.value = cost.value;

            this.modal_version = 'Cost';
        },
        editResult(result) {
            this.filter.data_source = result.data_source;
            this.filter.data_source_name = result.data_source_name;
            this.filter.title = result.description;
            this.filter.value = result.value;
            this.filter.date = result.date;
            this.filter.id = result.id;
            this.filter.emails = result.emails;
            this.filter.gifts = result.gifts;
            this.filter.revenue = result.revenue;
            this.filter.new_donors = result.new_donors;
            this.filter.recurring_revenue = result.recurring_revenue;
            this.filter.exclude_other_initiatives = result.exclude_other_initiatives;
            this.modal_version = 'Result';
        },
        previewTable(item) {
            this.table_data = "";
            item.client_id = this.client.id;

            //If it is a data set...
            if(!isNaN(item.data_source)) {
                item.data_source_id = item.data_source;
                item.data_source = "dataset";
            }

            window.axios.post('/api/bigquery/get_detailed_samples', item)
                .then(response => {
                    if(response.status === 200) {
                        this.table_data = response.data.samples;
                    } else {
                        this.table_data = response.data.error;
                    }
                });
        },
        deleteCost(cost) {
            cost.initiative_id = this.initiative.id;

            window.axios.post('/api/cost/delete/' + cost.id, cost)
                .then(response => {
                    if(response.status === 200) {
                        this.form.successful = true;
                        this.modal_version = null;
                        this.init = response.data.initiative;
                        this.$emit('update:initiative', this.init);
                    } else {
                        this.form.error = true;
                        setTimeout(() => { this.form.error = false; }, 10000);
                    }
                });

            if(typeof this.init.costs_filter === 'object' && !Array.isArray(this.init.costs_filter))
                this.init.costs_filter = Object.entries(this.init.costs_filter);

            //Remove it from the array
            for(let i = 0; i < this.init.costs_filter.length; i++) {
                if(this.init.costs_filter[i].id === cost.id) {
                    this.init.costs_filter.splice(i, 1);
                    break;
                }
            }
        },
        deleteResult(result) {
            result.initiative_id = this.initiative.id;

            //I have to do a "post" instead of "delete" since I have to pass the initiative_id
            // in cases where it isn't an actual "Result" object
            window.axios.post('/api/result/delete/' + result.id, result)
                .then(response => {
                    if(response.status === 200) {
                        this.form.successful = true;
                        this.modal_version = null;
                        this.init = response.data.initiative;
                        this.$emit('update:initiative', this.init);
                    } else {
                        this.form.error = true;
                        setTimeout(() => { this.form.error = false; }, 10000);
                    }
                });

            if(typeof this.init.results_filter === 'object' && !Array.isArray(this.init.results_filter))
                this.init.results_filter = Object.entries(this.init.results_filter);

            //Remove it from the array
            for(let i = 0; i < this.init.results_filter.length; i++) {
                if(this.init.results_filter[i].id === result.id) {
                    this.init.results_filter.splice(i, 1);
                    break;
                }
            }
        },
        logicToString(logic, units) {
            const arr = [];
            for(let i = 0; i < units.length; i++) {
                let str = "<code>" + units[i].db_column.text + " " + units[i].operator + " ";

                //if it is a static date, just format it
                if(units[i].db_column.type === 'date' && units[i].is_static)
                    str += this.date(units[i].value);
                else if(units[i].db_column.type === 'float64' && !isNaN(units[i].value))
                    str += this.currency(units[i].value);
                else if(units[i].db_column.type === 'int' && !isNaN(units[i].value))
                    str += this.number(units[i].value);
                else if(typeof units[i].value === 'object' && units[i].value !== null)
                    str += units[i].value.text;
                else if(typeof units[i].operator === "string" && units[i].operator.indexOf("NULL") === -1)
                    str += units[i].value;
                else if(typeof units[i].operator !== "string" && units[i].operator.value !== null && units[i].operator.value.indexOf("NULL") === -1)
                    str += units[i].value;

                arr.push(str + "</code>");
            }
            for(let i = 0; i < arr.length; i++) {
                const str_num = String(i + 1);
                logic = logic.replaceAll(str_num, arr[i]);
            }
            return logic;
        }
    }
});
</script>
